import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Card, Form } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { RULES, validRule } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { EmptyValues } from './components/EmptyValues'
import { Filters } from './components/Filters'
import { Preview } from './components/Preview'
import { productivityColumnFilter } from './ProductivityColumnFilter'
import {
  ReportOfFarmersPortfolioColumnsFilter,
  actionColumnsFilter,
  actionDetailColumnsFilter,
  actionPlanColumnFilter,
  alternativeColumnsFilter,
  arrastaoColumnsFilter,
  cargaDadosColumnsFilter,
  electColumnsFilter,
  forecastColumnsFilter
} from './ReportFilterColumns'
import { filterNormalize } from './util/filterNormalize'
import { validateFilters } from './util/validateFilters'

const Reports = function ({ match, history }) {
  const [formValues, setFormValues] = useState({})
  const auth = useSelector((state) => state.auth)
  const [columnsSelected, setColumnsSelected] = useState([])
  const [columnsDynamic, setColumnsDynamic] = useState([])
  // Filters
  const [isFiltered, setIsFiltered] = useState(false)
  const [reportSelectedValues, setReportSelectedValues] = useState([])
  const [totalItems, setTotalItems] = useState(null)
  const [errors, setErrors] = useState({})
  const [isReportActionDetailFilter, setIsReportActionDetailFilter] = useState(false)
  const [selectedPageSize, setSelectedPagesize] = useState(20)
  const [selectedCurrentPage, setSelectedCurrentPage] = useState(1)
  const [basicFirst, setBasicFirst] = useState(0)

  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.REPORT)
    if (!hasAccess) {
      return history.push('/home')
    }
  }, [])

  useEffect(() => {
    const params = filterNormalize(formValues, true, selectedPageSize, selectedCurrentPage)
    filterReport(params)
  }, [selectedCurrentPage, selectedPageSize])

  useEffect(() => {
    setSelectedCurrentPage(1)
    setSelectedPagesize(20)
    setReportSelectedValues([])
  }, [formValues.reportFilterType])

  const setFieldValueWithState = (field, value) => {
    if (field !== 'otherFilters') {
      setIsFiltered(false)
    }

    setFormValues((prev) => ({
      ...prev,
      [field]: value,
      ...(field === 'reportFilterType' && { reportType: value })
    }))

    if (field === 'reportFilterType') {
      setErrors({})
      if (value === 'CADASTRO_ELEITOS') {
        setNewColumns(electColumnsFilter)
      }

      if (value === 'ELEITOS_E_ALTERNATIVOS') {
        setNewColumns(alternativeColumnsFilter)
      }
      if (value === 'VISITAS') {
        setNewColumns(actionColumnsFilter)
      }
      if (value === 'FORECAST') {
        setNewColumns(forecastColumnsFilter)
      }
      if (value === 'ARRASTAO') {
        setNewColumns(arrastaoColumnsFilter)
      }
      if (value === 'PRODUCTIVITY') {
        setNewColumns(productivityColumnFilter)
      }
      if (value === 'CARGA_DE_DADOS') {
        setNewColumns(cargaDadosColumnsFilter)
      }
      if (value === 'ACTION_PLAN') {
        setNewColumns(actionPlanColumnFilter)
      }
      if (value === 'CARTEIRA_DE_ELEITOS') {
        setNewColumns(ReportOfFarmersPortfolioColumnsFilter)
      }
      handleReportFilterType(value)
    }
  }

  const handleReportFilterType = (value) => {
    value === 'VISITAS_DETALHADA' ? setIsReportActionDetailFilter(true) : setIsReportActionDetailFilter(false)
  }

  const setNewColumns = (newSelectedColumns) => {
    setColumnsDynamic(newSelectedColumns)
    const selectedColuns = []
    newSelectedColumns.map((item) => {
      if (item.active) {
        item.field = item.field.slice(0, 63)
        return selectedColuns.push(item)
      }
    })
    setColumnsSelected(selectedColuns)
  }

  const setFieldValueWithFields = (fields) => {
    setFormValues((prevState) => ({
      ...prevState,
      ...fields
    }))
  }

  const clearFilter = () => {
    setFormValues({})
    setErrors({})
  }

  const applyFilter = () => {
    if (Object.keys(formValues).length > 0) {
      const params = filterNormalize(formValues, true, selectedPageSize, 1)
      filterReport(params)
    }
  }
  const handleClickFilter = async () => {
    setBasicFirst(0)
    await validateFilters({
      applyFilter,
      setErrors,
      userAuth: auth.auth,
      formValues,
      isReportActionDetail: isReportActionDetailFilter
    })
  }

  const filterReport = async (params, skipLoading = false) => {
    if (params.reportType !== undefined) {
      const apiMethods = {
        FORECAST: api.reportsForecastWithPagination,
        ARRASTAO: api.reportsArrastaoWithPagination,
        ELEITOS_E_ALTERNATIVOS: api.reportsEleitosEAlternativosWithPagination,
        CADASTRO_ELEITOS: api.reportsCadastroEleitosWithPagination,
        VISITAS: api.generateReportActionsWithPagination,
        VISITAS_DETALHADA: async () => {
          const fields = await request(
            api.getForms({
              referencedTable: 'action',
              referencedTypeId: params.actionTypeIds
            }),
            skipLoading
          )

          const [formattedFields] = fields.filter((res) => {
            return (
              +res.referencedTypeId === +params.actionTypeIds &&
              Object.assign(res, {
                groupFormFields: groupBy(res.formFields, 'fieldGroup')
              })
            )
          })

          const response = await request(api.generateReportActionsDetailsWithPagination(params), skipLoading)

          if (response.data.length > 0) {
            let formattedCustomFieldsColumns = []
            Object.entries(formattedFields.groupFormFields).forEach((gf) => {
              return gf[1].map((res) => {
                return formattedCustomFieldsColumns.push({
                  active: true,
                  headerName: res.fieldGroup === null ? res.fieldName : `${res.fieldGroup}: ${res.fieldName}`,
                  field: res.internalFieldName
                })
              })
            })

            let newColumns = actionDetailColumnsFilter.concat(formattedCustomFieldsColumns)

            setNewColumns(newColumns)
          }

          return response
        },
        PRODUCTIVITY: async () => {
          const response = await request(api.reportsProductivity(params), skipLoading)
          return response.reduce((acc, item) => [...acc, ...handleVarietyData(item)], [])
        },
        CARGA_DE_DADOS: api.reportsCargaDeDadosWithPagination,
        ACTION_PLAN: api.generateActionPlanReportsWithPagination,
        CARTEIRA_DE_ELEITOS: api.generateFarmersPortfolioWithPagination
      }

      if (params.reportType in apiMethods) {
        const { data, totalItems } = await await request(apiMethods[params.reportType](params), skipLoading)
        setReportSelectedValues(data)
        setTotalItems(totalItems)
        setIsFiltered(true)
      }
    }
  }

  function handleVarietyData({ varieties = [], ...rest }) {
    return varieties.map((variety) => ({ ...rest, ...variety }))
  }

  function groupBy(array, key) {
    return array.reduce((result, currentValue) => {
      ;(result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue)
      return result
    }, {})
  }

  return (
    <section>
      <Form layout="vertical">
        <div style={style.container}>
          <div style={style.breadcrumb}>
            <CustomBreadcrumb match={match} history={history} />
          </div>
        </div>
        <Card className="ant-card gx-card ant-card-bordered">
          <Filters
            values={formValues}
            setFieldValueWithState={setFieldValueWithState}
            handleClickFilter={handleClickFilter}
            handleClickClearFilter={clearFilter}
            setFieldValueWithFields={setFieldValueWithFields}
            loggedUser={auth.auth}
            errors={errors}
          />
        </Card>
      </Form>
      <Card className="ant-card gx-card ant-card-bordered">
        {isFiltered ? (
          <Preview
            setColumnsSelected={setColumnsSelected}
            columnsDynamic={columnsDynamic}
            setColumnsDynamic={setColumnsDynamic}
            columnsSelected={columnsSelected}
            reportSelectedValues={reportSelectedValues}
            formValues={formValues}
            totalItems={totalItems}
            selectedPageSize={selectedPageSize}
            setSelectedPagesize={setSelectedPagesize}
            setSelectedCurrentPage={setSelectedCurrentPage}
            setFilterValue={setFieldValueWithState}
            filterReport={filterReport}
            basicFirst={basicFirst}
            setBasicFirst={setBasicFirst}
          />
        ) : (
          <EmptyValues />
        )}
      </Card>
    </section>
  )
}
const style = {
  container: {
    paddingBottom: '0.5rem'
  },
  breadcrumb: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    alignItems: 'center'
  }
}
export default Reports
